import { LocaleInput } from '../index.js'

export default {
  code: 'si-lk',
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // The week that contains Jan 4th is the first week of the year.
  },
  buttonText: {
    prev: 'පෙර',
    next: 'පසු',
    today: 'අද',
    month: 'මාසය',
    week: 'සතිය',
    day: 'දවස',
    list: 'ලැයිස්තුව',
  },
  weekText: 'සති',
  allDayText: 'සියලු',
  moreLinkText: 'තවත්',
  noEventsText: 'මුකුත් නැත',
} as LocaleInput
